module.exports = __webpack_public_path__ + "./fonts/icomoon.101dd3224ee102d19c9910f0546fa4d9.eot";